export const ellipsizetext = (input) => {
    return input.length < 20 ? input : input.slice(0,20)+"...";
}